module.exports = __webpack_public_path__ + "static/tlinh_mobile-4d4470dea094297e15b6a07786ed05c8.webp";